// extracted by mini-css-extract-plugin
export default {"formList":"index_formList_BuGSi","formHorizontal":"index_formHorizontal_vjmA0"};